import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import './css/style.less'
import * as util from '@/libs/util';
import {isNotNull, isNull, msg, msgs, msgh} from '@/libs/util';
import LyTab from 'ly-tab';


Vue.use(ElementUI);
Vue.use(LyTab);
Vue.config.productionTip = false
Vue.prototype.$util = util;
Vue.prototype.$isNull = isNull;
Vue.prototype.$isNotNull = isNotNull;
Vue.prototype.$msg = msg;
Vue.prototype.$msgs = msgs;
Vue.prototype.$msgh = msgh;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
